__webpack_require__.p = "https://cdn.xsolla.net/xsolla-babka/v-backpack-1588-01/";